<main>
  <app-hero />

  <!-- @if (showTrustBar()) {
    <app-trust-bar />
  } -->

  @if (showProblem()) {
    <app-problem />
  }

  @if (showIdealState()) {
    <app-ideal-state />
  }

  @if (showSolution()) {
    <app-solution />
  }

  @if (showFeatures()) {
    <app-features />
  }

  @if (showPsr()) {
    <app-problem-solution-result />
  }

  @if (showPortfolio()) {
    <app-portfolio />
  }

  @if (showServiceDirections()) {
    <app-service-directions />
  }

  @if (showProcess()) {
    <app-process />
  }

  @if (showQuoteRequest()) {
    <app-quote-request />
  }

  @if (showWebSupervision()) {
    <app-web-supervision />
  }

  @if (showPricing()) {
    <app-pricing />
  }

  @if (showWhyUs()) {
    <app-why-us />
  }

  @if (showFaq()) {
    <app-faq />
  }

  @if (showContactForm()) {
    <app-contact-cta />
  }
</main>
